import { hyperdbHandlers } from 'hyperdb-utils';

const handlers = hyperdbHandlers({ namespace: 'EMAIL_PROPERTY_DATA' });
export default {
  ...handlers,
  EMAIL_PROPERTY_DATA__UPLOAD_PDF(state) {
    return { ...state, uploadingPdf: true, errorMessage: null, uploadPdfSuccess: false };
  },
  EMAIL_PROPERTY_DATA__UPLOAD_PDF_SUCCESS(state, { payload }) {
    const savedPdf = payload;
    return { ...state, savedPdf, uploadingPdf: false, errorMessage: null, uploadPdfSuccess: true };
  },
  EMAIL_PROPERTY_DATA__DELETE_PDF(state) {
    return { ...state, deletingPdf: true, errorMessage: null, deletePdfSuccess: false };
  },
  EMAIL_PROPERTY_DATA__DELETE_PDF_SUCCESS(state) {
    return { ...state, deletingPdf: false, errorMessage: null, deletePdfSuccess: true };
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/email/property-data/handlers.js